import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

interface BreadcrumbItem {
  name: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.path ? `https://www.free91.com${item.path}` : undefined,
    })),
  };

  const categoryMap = new Map(categories.map((c) => [c.slug, c.name]));

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-sm text-foreground-600">
        {items.map((item, index) => (
          <span key={index} className="flex items-center gap-1.5">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-xs text-foreground-300"></i>
            )}
            {item.path ? (
              <Link
                to={item.path}
                className="hover:text-primary-500 transition-colors whitespace-nowrap"
              >
                {categoryMap.get(item.name) || item.name}
              </Link>
            ) : (
              <span className="text-foreground-800 font-medium whitespace-nowrap">
                {categoryMap.get(item.name) || item.name}
              </span>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}